import React from 'react';

export interface Column<T> {
  key: keyof T | string;
  header: string | React.ReactNode;
  className?: string;
  render?: (row: T) => React.ReactNode;
}

export interface TableProps<T> {
  columns: Column<T>[];
  data: T[];
  emptyMessage?: string;
}

const Table = <T,>({ columns, data, emptyMessage = 'No data' }: TableProps<T>): React.ReactElement => {
  return (
    <div className="bg-[var(--surface)] rounded-md shadow border border-[var(--border)] overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-sm min-w-max">
          <thead>
            <tr className="table-header">
              {columns.map((col) => (
                <th
                  key={String(col.key)}
                  className={"text-left font-medium px-4 py-3 border-b border-[var(--border)] " + (col.className || '')}
                >
                  {col.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td className="px-4 py-8 text-center text-[var(--text-muted)]" colSpan={columns.length}>
                  {emptyMessage}
                </td>
              </tr>
            ) : (
              data.map((row, idx) => (
                <tr key={idx} className="border-b border-[var(--border)] hover:bg-[var(--surface-alt)]">
                  {columns.map((col) => (
                    <td key={String(col.key)} className={"px-4 py-3 " + (col.className || '')}>
                      {col.render ? col.render(row) : (row as any)[col.key as string]}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table; 